import BlockIcon from '@mui/icons-material/Block';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { tokens } from '../../../design';

/**
 * Drawer footer (AUT-400): «Отключить подборщика» for an active picker,
 * «Включить обратно» for a disabled one. No TOTP pill — AUT-138 removed the
 * per-action step-up; the write is role + permission + audit gated.
 */
export const PickerDetailFooter = ({
  disabled,
  busy,
  onDisable,
  onEnable,
}: {
  disabled: boolean;
  busy: boolean;
  onDisable: () => void;
  onEnable: () => void;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        p: '14px 24px',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {disabled ? (
        <Button
          variant="contained"
          disabled={busy}
          onClick={onEnable}
          data-testid="picker-enable-button"
          startIcon={<RestartAltIcon />}
        >
          {t('pickers.actions.enable')}
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="error"
          disabled={busy}
          onClick={onDisable}
          data-testid="picker-disable-button"
          startIcon={<BlockIcon />}
        >
          {t('pickers.actions.disable')}
        </Button>
      )}
      <Box
        sx={{
          ml: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          fontSize: 11,
          color: tokens.text.tertiary,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 12 }} />
        {t(disabled ? 'pickers.actions.enableNote' : 'pickers.actions.auditNote')}
      </Box>
    </Box>
  );
};
